// Author: Conary Hernandez - Marzo 2019
// Esto lo tuvo que haber hecho lencho 😬

import React, { Component } from 'react';
import utils from 'js/modules/utils';

class SubmitLoader extends Component {
  constructor(props) {
    super(props);

    this.elBody = document.querySelector('body');
  }

  _loaderHandler = (isActive = false, isScrollable = false) => {

    const noScroll = 'util-no-flow-submit';

    if (isActive && !isScrollable) {
      utils.addClass(this.elBody, noScroll);
    } else {
      utils.removeClass(this.elBody, noScroll);
    }
  };

  render() {
    const { isActive = false, isScrollable = false } = this.props;

    this._loaderHandler(isActive, isScrollable);

    return (
      <div className={`large-loader ${isActive ? 'active-loader' : 'inactive-loader'}`}>
        <div className="loader" />
        <div className="loader-msg">
          <p>Book online and get $100 off</p>
        </div>
      </div>
    );
  }
}

export default SubmitLoader;



// WEBPACK FOOTER //
// ./js/components/global/SubmitLoader.js